exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-btn[data-v-3fad2a52]{font-size:.675rem;margin-left:5px;margin-bottom:4px}.card[data-v-3fad2a52]{border:1px solid #ddd;border-radius:8px;margin:10px;box-shadow:0 4px 8px rgba(0,0,0,.1);transition:transform .3s ease,opacity .5s ease}.card[data-v-3fad2a52]:hover{transform:scale(1.05)}.card-header[data-v-3fad2a52]{background-color:#3498db;color:#fff;padding:10px;font-weight:700}.card-body[data-v-3fad2a52]{padding:15px}.client-details[data-v-3fad2a52]{margin-top:10px;color:#555}a[data-v-3fad2a52]{color:#3498db;font-weight:700;text-decoration:none}a[data-v-3fad2a52]:hover{text-decoration:underline}.fade-in-enter-active[data-v-3fad2a52],.fade-in-leave-active[data-v-3fad2a52]{transition:opacity .5s}.fade-in-enter[data-v-3fad2a52],.fade-in-leave-to[data-v-3fad2a52]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fad2a52","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/ShipmentTrackCard.vue
// module id = 1530
// module chunks = 0